<template>
  <v-navigation-drawer
    v-model="inputValue"
    :mobile-breakpoint="breakPoint"
    :touchless="true"
    width="300"
  >
    <v-spacer class="mt-2" />

    <v-list dense nav>
      <template v-for="link in links">
        <v-list-group
          v-if="link.grouplist"
          :key="link.title"
          :value="link.title"
          :type="link.type"
          :role="link.role"
        >
          <template v-slot:activator="{ props }">
            <v-list-item
              v-bind="props"
              :prepend-icon="link.icon"
              :title="link.title"
            />
          </template>
          <v-list-item
            v-for="item in link.items"
            :key="item.key"
            :to="item.to"
            :title="$t(item.title)"
          />
        </v-list-group>
        <v-list-item
          v-else
          :key="link.title"
          :to="link.to"
          :type="link.type"
          :role="link.role"
          :prepend-icon="link.icon"
          :title="link.title"
        />
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    links: Array,
  },
  data: () => ({
    breakPoint: 5000,
  }),
  mounted() {
    this.updateNavigationState();
  },
  computed: {
    inputValue: {
      get() {
        return this.drawer();
      },
      set(val) {
        this.setDrawer(val);
      },
    },
  },
  methods: {
    ...mapActions('ui', ['setDrawer']),
    ...mapGetters('ui', ['drawer']),

    // ナビゲーションの状態を更新する
    updateNavigationState() {
      // ウィンドウの横幅が基準点以上であるかどうかで判定
      this.setDrawer(window.innerWidth >= this.breakPoint);
    },
  },
};
</script>
